import "../src/global/global-mobile"

import "@modules/vue-modals/ad-free"

import "@modules/static-pages/mobile.css"
import "@modules/static-pages/mobile_Inserieren_Form.css"
import "@modules/static-pages/mobile_contact_Form.css"
import "@modules/solads/solads"
import "@modules/traffic-stars/traffic-stars"
import { setAZMFilterPath } from "@modules/global/filter-path/filter-path-handler.ts"

setAZMFilterPath()
